import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Typography from '@mui/material/Typography';
import { black500 } from '@ui/constants/color';
import { Box } from '@mui/material';
export const Datepicker = ({ label, disabled = false, onDateChange, value, errormsg, minDate }) => {
    const [dateValue, setValue] = React.useState(null);
    return (_jsxs(Box, { width: '100%', position: 'relative', children: [label && (_jsx(Typography, { mb: '2px', variant: 'subtitle2', color: black500, children: label })), _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(DatePicker, { disabled: disabled, minDate: minDate, sx: {
                        width: '100%',
                        pt: 0,
                        '& .MuiOutlinedInput-root': {
                            '& .MuiIconButton-root': {
                                // display: 'none'
                                marginRight: '1px'
                            },
                            '& .Mui-focused fieldset': {
                                borderColor: '#ECECEC'
                            }
                        }
                    }, value: value, onChange: (newValue) => {
                        setValue(newValue);
                        if (onDateChange) {
                            onDateChange(newValue);
                        }
                    }, format: 'DD-MM-YYYY', defaultValue: value }) }), errormsg && (_jsx(Box, { sx: {
                    position: 'absolute',
                    width: '100%',
                    left: 0,
                    transition: 'transform 0.3s ease, opacity 0.3s ease',
                    transform: errormsg ? 'translateY(0)' : 'translateY(20px)'
                }, children: _jsx(Typography, { letterSpacing: 0, fontSize: '12px', fontWeight: 500, color: '#FF0000', children: errormsg }) }))] }));
};
